import * as Sentry from "@sentry/react";

const DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!DSN) return; // graceful no-op until DSN is provided
  Sentry.init({
    dsn: DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

/**
 * Drop-in replacement for console.error.
 * - Always logs to console in dev (preserves current DX).
 * - Captures to Sentry when DSN is configured.
 */
export function captureError(...args) {
  // Preserve dev-time console output
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
  if (!DSN) return;
  const errArg = args.find((a) => a instanceof Error);
  const message = args.filter((a) => typeof a === "string").join(" ");
  if (errArg) {
    Sentry.captureException(errArg, { extra: { message } });
  } else if (message) {
    Sentry.captureMessage(message, "error");
  }
}
